/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Video from '../../components/Video';
import Service from '../../components/ServiceAccueil';
import Realisation from '../../components/RealisationAccueil';
import Blogue from '../../components/BlogueAccueil';
import Propos from '../../components/ProposAccueil';
import s from './Accueil.css';

@withStyles(s)
export default class Accueil extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accueil: []
        };

    }

    componentDidMount() {
        this.GetAccueilPage();
    }

    async GetAccueilPage() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 86400000*7,
            },
            body: JSON.stringify({
                query: '{accueil{id, slug, title, content, texteRealisation, ctaRealisation, texteBlogue, ctaBlogue, textePropos, ctaPropos}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.accueil) throw new Error('Erreur sur le chargement de l`accueil !');
        
        this.setState({ accueil: data.accueil })
    }

    render() {
       return (
            <div className={s.root}>
                <div className={`accueil`}>
                    <main role="main">
                        <Video />
                        
                    </main>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/accueil/Accueil.js